import { render, staticRenderFns } from "./FriendlyLink.vue?vue&type=template&id=1ef7aaa8&scoped=true"
import script from "./FriendlyLink.vue?vue&type=script&lang=js"
export * from "./FriendlyLink.vue?vue&type=script&lang=js"
import style0 from "./FriendlyLink.vue?vue&type=style&index=0&id=1ef7aaa8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef7aaa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef7aaa8')) {
      api.createRecord('1ef7aaa8', component.options)
    } else {
      api.reload('1ef7aaa8', component.options)
    }
    module.hot.accept("./FriendlyLink.vue?vue&type=template&id=1ef7aaa8&scoped=true", function () {
      api.rerender('1ef7aaa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/FriendlyLink.vue"
export default component.exports